module.exports = __webpack_public_path__ + "img/default.d4b45420.jpg";